module.exports = __webpack_public_path__ + "media/assets/images/banner@3x-b2794ce0df1f1faec25af1381ec34db1.png";